<template>
	<div :class="$style.unPaid">
		<div class="unpaidPrepaidForm__all">
			<div class="unpaidPrepaidForm__right" style="border-right: #dcdfe6 1px solid">
				<div class="unpaidPrepaidForm__right__header">
					<button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeThisComp"><i
							class="el-dialog__close el-icon el-icon-close"></i></button>
					<h4 class="unpaidPrepaidForm__right__title">
						<div class="inline-between" style="padding-right: 15px; align-items: center">
							<span> 選擇欲付款{{ $t('prepaid.BASE') }}訂單 </span>
						</div>
					</h4>
				</div>
			</div>
			<div :class="$style['unPaid__content']">
				<div v-for="item in prepaidOrders" :class="$style['unPaid__Btn']">
					<div :class="$style['unPaid__Btn__serviceTitle']">
						<p :class="$style['unPaid__Btn__serviceTitle__type']">{{ $t('prepaid.BASE') }}訂單</p>
						<p :class="$style['unPaid__Btn__serviceTitle__title']">{{ item.serviceDetail.title }}
						</p>
					</div>
					<el-button class="is-round" type="primary" :class="$style['unPaid__Btn__main']"
						@click="goPayForPrepaid(item.orderDetail)">前往付款{{ $t('prepaid.BASE') }}訂單</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Hello',
	data() {
		return {};
	},
	props: {
		containerOrders: {
			type: Object,
			default: () => { },
		}
	},
	watch: {},
	computed: {
		prepaidOrders() {
			try {
				let result = []
				if (Object.keys(this.containerOrders).length > 0) {
					result = this.containerOrders.orders.reduce((accu, cur) => {
						if (cur.prepaidOrderStatus === 2) {
							accu.push({
								'serviceDetail': this.findItemByType('cosmetic', cur),
								'title': `${this.$t('prepaid.BASE')}訂單`,
								'orderDetail': cur
							})
						}
						return accu
					}, [])
				}
				return result
			} catch (error) {
				console.error(error.message)
			}
		}
	},
	created() { },
	mounted() {
	},
	methods: {
		closeThisComp(){
			this.$emit('closeThisComp')
		},
		/**
		 * @description 找到這個服務的title
		 * @param {*} itemType 哪種type
		 * @param {*} order 訂單結構內容 
		 */
		findItemByType(itemType = '', order) {
			return order.params.find(({ type }) => type === itemType) || {}
		},
		/**
		 * @description 前往付款包月訂單
		 */
		goPayForPrepaid(prepaidItem) {
			this.$emit('goPayForPrepaid', prepaidItem)
		},
	},
	components: {},
};
</script>

<style lang="scss" module>
.unPaid {
	:global {
		.unpaidPrepaidForm {
			&__all {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				height: 100%;
			}


			&__right {
				position: relative;
				width: 100%;
				overflow: hidden;
				background: $color-line;

				.unpaidPrepaidForm__right__header {
					background-color: $color-line;
					z-index: 999;
				}

				&__title {
					margin: 0;
					padding: 19px 0;
					padding-left: 50px;
				}

				&__header {
					position: relative;
					border-bottom: $color-border-base 1px solid;

					.el-drawer__close-btn {
						// font-weight: 300;
						color: #72767b;
						position: absolute;
						padding: 15px;
						border: 0;
						left: 0;
						top: 3px;
					}

					.el-tabs__item {
						height: auto;
						padding: 10px 0;
					}

					.el-tabs__nav-wrap::after {
						display: none;
					}

					.el-tabs__header {
						margin-bottom: 0;
					}

					.el-tabs--top {
						margin-left: 60px;

						@include max-lg {
							margin-left: 30px;
						}
					}
				}

				&__content {
					z-index: 10;
					height: calc(100vh - 60px);
					overflow: auto;
					padding: 30px;
					padding-bottom: 120px;
					position: relative;
					background-color: $color-line;

					@include max-lg {
						padding: 20px;
					}
				}
			}

		}
	}

	&__content {
		padding: 20px;
		width: 100%;
	}

	&__Btn {
		display: flex;
		flex-direction: column;
		padding: 16px 18px;
		background-color: white;
		border-radius: $border-radius;
		justify-content: center;
		width: 100%;
		margin-bottom: 20px;
		border: 1px solid $color-line-dark;
		&__serviceTitle {
			display: flex;

			&__type {
				margin-right: 8px;
				color: $color-secondary;
			}
		}

		&__main {
			padding-top: 12px;
			padding-bottom: 12px;
		}
	}
}</style>
